import { render } from "./BrowseBrands.vue?vue&type=template&id=6fcc98bf&scoped=true"
import script from "./BrowseBrands.vue?vue&type=script&lang=js"
export * from "./BrowseBrands.vue?vue&type=script&lang=js"

import "./BrowseBrands.vue?vue&type=style&index=0&id=6fcc98bf&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcc98bf"]])

export default __exports__